import React from 'react'

function About() {
    return (
        <section id="about" class="about-mf sect-pt4 route">
            <div class="container">
                <div class="row">
                    <div class="col-sm-12">
                        <div class="box-shadow-full mb-1">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="row">
                                        <div class="col-sm-6 col-md-5">
                                            <div class="about-img">
                                                <img src="img/IMG-20220615-WA0005.jpg" class="img-fluid rounded b-shadow-a" alt="" />
                                            </div>
                                        </div>
                                        <div class="col-sm-6 col-md-7 mt-4">
                                            <div class="about-info">
                                                <p><span class="title-s">Name: </span> <span>Mathubala G</span></p>
                                                <p><span class="title-s">Qualification: </span> <span>MCA</span></p>
                                                <p><span class="title-s">Profile: </span> <span>Full Stack Developer</span></p>
                                                <p><span class="title-s">Email: </span> <span>madhuvalar.govindaraj@gmail.com</span></p>
                                                
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="skill-mf">
                                            <h1>...</h1>
                                        </div>

                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="about-me pt-4 pt-md-0">
                                        <div class="title-box-2">
                                            <h5 class="title-left">
                                                About me
                                            </h5>
                                        </div>
                                        <p class="lead">
                                            Hi, I am Mathubala, growing myself as a fullstack developer was learned from my self interest.
                                            I definitely have a passion for programming and would like to make it into a career.                                         
                                        </p>  
                                        <p class="lead">                                            
                                        Consider to bringing me into your organization. 
                                        I learn fast and am looking forward to being a value-added employee as fast as possible!                                      
                                        </p>                                       
                                        <p class="lead">                                       
                                        I am also skilled in web development,also proficient in Back-end development 
                                        and Database. I love to work with Web technologies like React and built some projects using the same, 
                                        including this website(My Portfolio).
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </section>
    )
}

export default About
